import React, { useState, useEffect } from "react";

export default function ColoredLogo({
  src,
  color = "black",
  size = 32,
  style = {},
  ...props
}) {
  const [aspectRatio, setAspectRatio] = useState(1);

  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.src = src;
    img.onload = () => {
      if (img.naturalHeight === 0) return;
      setAspectRatio(img.naturalWidth / img.naturalHeight);
    };
  }, [src]);

  return (
    <>
      {/* Hidden img to get size */}
      <img src={src} alt="" style={{ display: "none" }} aria-hidden="true" />

      <div
        style={{
          height: size + "px",
          width: size * aspectRatio + "px",
          backgroundColor: color,
          WebkitMaskImage: `url(${src})`,
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskSize: "contain",
          WebkitMaskPosition: "center",
          maskImage: `url(${src})`,
          maskRepeat: "no-repeat",
          maskSize: "contain",
          maskPosition: "center",
          display: "inline-block",
          ...style,
        }}
        {...props}
      />
    </>
  );
}
